module.exports = __webpack_public_path__ + "static/media/upload.61293e60.svg";